import { render, staticRenderFns } from "./formulir-payroll-gaji.vue?vue&type=template&id=45226632"
import script from "./formulir-payroll-gaji.vue?vue&type=script&lang=js"
export * from "./formulir-payroll-gaji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports